/**
 * LeisureMod Commercial — Why Choose Us pinned card stack
 * While scrolling through the tall driver element, maps scroll position
 * to a 0–1 progress value per row (rows 1+; row 0 is a simple viewport
 * entrance instead, since it's already resolved by the time the pin
 * engages) and transforms each from off-screen — alternating left/right
 * to match its "side" — to centered, covering the row beneath it. Runs
 * every scroll tick as a direct function of scroll position, so
 * scrolling back up naturally reverses it — no separate "reverse" logic
 * needed.
 *
 * Same defensive pattern used elsewhere in this project: "js-ready" is
 * only added once real content has been confirmed. Content stays
 * visible by default; the CSS only hides/positions things once this
 * class is present, so a script failure leaves everything in its
 * natural, readable stacked-list state instead of stuck invisible or
 * scattered off-screen.
 */
(function () {
	function clamp(value, min, max) {
		return Math.max(min, Math.min(max, value));
	}

	function init() {
		var section = document.querySelector("[data-why-choose-us]");
		if (!section) return;

		var driver = section.querySelector("[data-wcu-driver]");
		var intro = section.querySelector(".why-choose-us__intro");
		var rows = section.querySelectorAll("[data-wcu-row]");
		if (!driver || !rows.length) return;

		section.classList.add("js-ready");

		var firstRow = null;
		var scrollRows = [];
		rows.forEach(function (row) {
			if (row.getAttribute("data-wcu-index") === "0") {
				firstRow = row;
			} else {
				scrollRows.push(row);
			}
		});

		// Only run the pinned scroll-drive on desktop/tablet widths that
		// match the CSS breakpoint (1024px+) — below that, the section
		// falls back to a plain stacked list via CSS, so no scroll math
		// is needed or wanted there.
		var mql = window.matchMedia("(min-width: 1024px)");

		function updateStack() {
			if (!mql.matches || !scrollRows.length) return;
			var rect = driver.getBoundingClientRect();
			var totalScrollable = driver.offsetHeight - window.innerHeight;
			if (totalScrollable <= 0) return;
			var scrolled = clamp(-rect.top, 0, totalScrollable);
			var progress = scrolled / totalScrollable;
			var segment = 1 / scrollRows.length;

			scrollRows.forEach(function (row, i) {
				var cardProgress = clamp((progress - i * segment) / segment, 0, 1);
				var side = row.getAttribute("data-wcu-side");
				var startPercent = side === "left" ? -110 : 110;
				var x = startPercent * (1 - cardProgress);
				row.style.transform = "translateX(" + x.toFixed(2) + "%)";
			});
		}

		var ticking = false;
		function onScroll() {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(function () {
				updateStack();
				ticking = false;
			});
		}

		window.addEventListener("scroll", onScroll, { passive: true });
		window.addEventListener("resize", onScroll);
		mql.addEventListener ? mql.addEventListener("change", updateStack) : mql.addListener(updateStack);

		// Run once immediately so rows are correctly positioned from the
		// start, regardless of where the page happens to be scrolled to
		// on load.
		updateStack();

		// First row + intro: simple viewport-entrance reveal, replaying in
		// both directions like the other sections on this site.
		var revealTargets = [intro, firstRow].filter(Boolean);
		if ("IntersectionObserver" in window) {
			var io = new IntersectionObserver(
				function (entries) {
					entries.forEach(function (entry) {
						entry.target.classList.toggle("is-visible", entry.isIntersecting);
					});
				},
				{ threshold: 0.2, rootMargin: "0px 0px -60px 0px" }
			);
			revealTargets.forEach(function (el) {
				io.observe(el);
			});
		} else {
			revealTargets.forEach(function (el) {
				el.classList.add("is-visible");
			});
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();